import React, { useState } from "react";
import {
  Nav,
  Navbar,
  NavbarToggler,
  Collapse,
  NavItem,
  NavLink,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { NavLink as RRNavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import isElectron from "../utils/isElectron";

import "./Navigation.scss";

function Navigation() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Navbar expand="md" className="Navbar" light tag="div">
      <NavbarBrand to="/" tag={RRNavLink} className="AppName">
        <img src="/NNSA_Logo.png" alt="NNSA Logo" className="NavbarImage" />{" "}
        {t("AP Declaration Helper")}
      </NavbarBrand>
      <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="ml-auto" navbar>
          <NavItem>
            <NavLink to="/interview" tag={RRNavLink}>
              {t("Interview")}
            </NavLink>
          </NavItem>
          {!isElectron() && (
            <NavItem>
              <NavLink to="/downloads" tag={RRNavLink}>
                {t("Downloads")}
              </NavLink>
            </NavItem>
          )}
          <UncontrolledDropdown nav inNavbar>
            <DropdownToggle nav caret>
              {t("Help")}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem tag={RRNavLink} to="/faq">
                {t("Frequently Asked Questions")}
              </DropdownItem>
              <DropdownItem tag={RRNavLink} to="/help">
                {t("Help")}
              </DropdownItem>
              <DropdownItem tag={RRNavLink} to="/contact">
                {t("Contact")}
              </DropdownItem>
              {/* {!isElectron() && (
                <DropdownItem tag={RRNavLink} to="/video">
                  {t("AP Training Videos")}
                </DropdownItem>
              )} */}
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
      </Collapse>
    </Navbar>
  );
}

export default Navigation;
